import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-eeffe50e")

_pushScopeId("data-v-eeffe50e")
const _hoisted_1 = { style: {"text-align":"left","margin-top":"30px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Back to login ")
const _hoisted_3 = {
  key: 0,
  class: "app"
}
const _hoisted_4 = { class: "content-main" }
const _hoisted_5 = {
  key: 1,
  class: "app"
}
const _hoisted_6 = { class: "content-main" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_app_navbar_started = _resolveComponent("app-navbar-started")
  const _component_el_header = _resolveComponent("el-header")
  const _component_app_main = _resolveComponent("app-main")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_app_sidebar = _resolveComponent("app-sidebar")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_app_navbar = _resolveComponent("app-navbar")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      "close-on-click-modal": false,
      "show-close": false,
      "close-on-press-escape": false,
      modelValue: _ctx.isShowChangeAccount,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowChangeAccount = $event)),
      title: "Select Account",
      width: "700px"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table, { data: _ctx.accounts }, {
          default: _withId(() => [
            _createVNode(_component_el_table_column, { label: "Please choose an account" }, {
              default: _withId((scope) => [
                _createVNode(_component_el_row, {
                  class: "hover",
                  onClick: ($event: any) => (_ctx.handleChooseAccount(scope.row))
                }, {
                  default: _withId(() => [
                    _createVNode("p", null, _toDisplayString(scope.row.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode("footer", _hoisted_1, [
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.backToLogin()))
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.checkAuthenticDone && _ctx.pageTitle == 'Get Started')
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_el_container, { class: "layout-container-demo" }, {
            default: _withId(() => [
              _createVNode(_component_el_container, null, {
                default: _withId(() => [
                  _createVNode(_component_el_header, null, {
                    default: _withId(() => [
                      _createVNode(_component_app_navbar_started)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_main, { style: {"overflow":"unset"} }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_4, [
                        _createVNode(_component_app_main)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.checkAuthenticDone && _ctx.pageTitle != 'Get Started')
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_el_container, { class: "layout-container-demo" }, {
            default: _withId(() => [
              _createVNode(_component_el_aside, {
                class: "sidebar",
                width: "180px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_scrollbar, null, {
                    default: _withId(() => [
                      _createVNode(_component_app_sidebar, {
                        isCollapse: _ctx.isCollapse,
                        onFinishHandle: _ctx.handleSidebar
                      }, null, 8, ["isCollapse", "onFinishHandle"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_container, {
                class: [_ctx.isCollapse ? 'collapse' : 'in-collapse']
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_header, null, {
                    default: _withId(() => [
                      _createVNode(_component_app_navbar)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_main, { style: {"overflow":"unset"} }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_6, [
                        _createVNode(_component_app_main)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
})